import useSplits from './useSplits'

export default useSplits
